"use client";

import type { ToolUIRegistry } from "@bg-bgi/magnus-sdk/react";
import { lazy } from "react";

export const weatherToolRegistry = {
  getWeather: {
    kind: "standalone",
    category: "weather",
    view: lazy(() =>
      import("./get-weather").then(({ GetWeatherToolView }) => ({
        default: GetWeatherToolView,
      }))
    ),
  },
} satisfies ToolUIRegistry;
